var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-editor',{attrs:{"permission":"page","fields":_vm.fields,"publication":true,"hasAuthor":false,"previewModule":"page","endpoint":"page","module":"page"},on:{"update":_vm.updateState}})}
var staticRenderFns = []

export { render, staticRenderFns }